/** Mirrors eventcalendar-api/services/billingPlans.js and billingEntitlements.js */

export const FREE_TEMPLATE_ID = "classic-forest";
export const FREE_MAX_EVENTS = 1;

export function isBillableShop(shopInfo) {
  return String(shopInfo?.user_type) === "0";
}

export function eventStartMs(ev) {
  const raw = ev?.startAt || ev?.start_at || "";
  const t = Date.parse(raw);
  return Number.isFinite(t) ? t : Number.POSITIVE_INFINITY;
}

export function countWidgetEvents(widgets, exceptWidgetId) {
  let total = 0;
  for (const widget of widgets || []) {
    if (exceptWidgetId != null && String(widget?.id) === String(exceptWidgetId)) continue;
    for (const ev of widget?.events || []) {
      if (ev && ev.id) total += 1;
    }
  }
  return total;
}

export function pickPublishedEventId(widgets) {
  const rows = [];
  for (const widget of widgets || []) {
    for (const ev of widget?.events || []) {
      if (ev && ev.id) rows.push(ev);
    }
  }
  const visible = rows.filter((ev) => !ev.hidden);
  const pool = visible.length ? visible : rows;
  pool.sort((a, b) => {
    const delta = eventStartMs(a) - eventStartMs(b);
    if (delta !== 0) return delta;
    return String(a.id).localeCompare(String(b.id));
  });
  return pool[0] ? String(pool[0].id) : null;
}

export function pickPublishedWidgetId(widgets) {
  const eventId = pickPublishedEventId(widgets);
  if (!eventId) return null;
  for (const widget of widgets || []) {
    for (const ev of widget?.events || []) {
      if (ev && String(ev.id) === eventId) return String(widget.id);
    }
  }
  return null;
}
